import { render, staticRenderFns } from "./ProductPopSearchSlotPanel.vue?vue&type=template&id=3227e00b&"
import script from "./ProductPopSearchSlotPanel.vue?vue&type=script&lang=ts&"
export * from "./ProductPopSearchSlotPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPopSearchSlotPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports